import Icon from '../components/Icon';

const CollRocky = Icon(
  'coll-rocky',
  <>
    <path d="M24 23.368a.63.63 0 0 1-.632.632H21v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1h-4v-1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1H7v-1a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1H1.895A1.895 1.895 0 0 1 0 22.105V20.45a.25.25 0 0 1 .18-.24H24zM10.559 0c.618 0 1.146.448 1.247 1.059L12.125 3H10.5a1 1 0 0 0 0 2h1.953l.33 2H11a1 1 0 1 0 0 2h2q.055 0 .11-.007l.183 1.118a1.5 1.5 0 0 0 1.48 1.257h4.174A5.053 5.053 0 0 1 24 16.421v2.527H.5V1.263C.5.565 1.065 0 1.763 0z" />
  </>
);

export default CollRocky;
